import { useState, useEffect } from 'react'
import { TypingEffect } from '../typing-effect/typing-effect'

interface AnimatedSloganProps {
  fullText: string
  changeableWords: string[]
  changeableWordIndex: number
  className?: string
}

export const AnimatedSlogan = ({
  fullText,
  changeableWords,
  changeableWordIndex,
  className = ''
}: AnimatedSloganProps) => {
  const [isInitialTypingComplete, setIsInitialTypingComplete] = useState(false)
  const [displayText, setDisplayText] = useState('')
  const [cursorVisible, setCursorVisible] = useState(true)

  // Анимация печати и движения курсора
  useEffect(() => {
    if (isInitialTypingComplete) return

    const TYPING_DELAY = 150

    if (displayText.length < fullText.length) {
      const timer = setTimeout(() => {
        setDisplayText(fullText.slice(0, displayText.length + 1))
      }, TYPING_DELAY)
      return () => clearTimeout(timer)
    } else {
      const timer = setTimeout(() => {
        setIsInitialTypingComplete(true)
      }, 800)
      return () => clearTimeout(timer)
    }
  }, [fullText, displayText, isInitialTypingComplete])

  // Анимация мигающего курсора
  useEffect(() => {
    const cursorTimer = setInterval(() => {
      setCursorVisible((prev) => !prev)
    }, 530)
    return () => clearInterval(cursorTimer)
  }, [])

  if (isInitialTypingComplete) {
    const words = fullText.split(' ')
    const prefix = words.slice(0, changeableWordIndex).join(' ') + ' '
    const suffix = ' ' + words.slice(changeableWordIndex + 1).join(' ')

    return (
      <TypingEffect prefix={prefix} words={changeableWords} suffix={suffix} className={className} />
    )
  }

  return (
    <span className={className}>
      <span className="relative inline-block w-full whitespace-normal break-words">
        {displayText}
        <span
          className={`absolute inline-block w-[2px] h-[1.2em] bg-black dark:bg-white transition-opacity duration-100 ${
            cursorVisible ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            left: 'calc(100% + 1px)',
            transform: 'translateX(-100%)',
            top: '0.1em'
          }}
        />
      </span>
    </span>
  )
}
